import AgentGif from "../../assets/agenttest.gif";
import MlmBiasAclPosterSnippet from "../../assets/mlm-bias-acl-poster-snippet.png";
import BboxGradCamExample from "../../assets/bbox_gradcam_example.png";
import GailAlgorithmSnippet from "../../assets/gail-algorithm-snippet.png";
import PositionTrackingSnippet from "../../assets/position-tracking-snippet.png";
import ByteMagazineCoverExample from "../../assets/byte-magazine-cover-dec-1975.png";
import UndirectedGraphExample from "../../assets/undirected-graph-example.png";

const content = [
  {
    type: "research",
    media: MlmBiasAclPosterSnippet,
    authors: <span><strong>Rahul Zalkikar*</strong> and Kanchan Chandra</span>,
    year: 2025,
    title: "Measuring Social Biases in Masked Language Models by Proxy of Prediction Quality",
    journal: "Proceedings of the 63rd Annual Meeting of the Association for Computational Linguistics (ACL)",
    arxivLink: "https://arxiv.org/abs/2402.13954",
    pdfLink: process.env.PUBLIC_URL + "/papers/BiasMLMs.pdf",
    codeLink: "https://github.com/zalkikar/mlm-bias",
    aclLink: "https://aclanthology.org/2025.acl-long.68/",
    pdfColor: "grey",
    note: "Main Conference, Long Paper (* = corresponding author)",
    description: "Attention-weighted proxy functions to measure social biases in masked language models (MLMs) "+
                 "by masked token prediction quality under an iterative masking experiment, "+
                 "which produce more accurate and sensitive estimations of biases introduced by retraining MLMs "+
                 "under the masked language modeling objective."
  },
  {
    type: "research",
    media: UndirectedGraphExample,
    authors: <span>Kanchan Chandra and <strong>Rahul Zalkikar</strong></span>,
    year: 2025,
    title: "Implicit and Explicit Appeals in Campaign Messages",
    journal: "Working paper",
    arxivLink: null,
    pdfLink: null,
    codeLink: null,
    aclLink: null,
    pdfColor: "grey",
    note: null,
    description: "Methods to detect coded appeals in natural language that leverage semantic text representations through "+
                 "static word embeddings learned by GloVe and Word2Vec in a variety of contexts.",
  },
  {
    type: "research",
    media: GailAlgorithmSnippet,
    authors: <span>Noah Kasmanoff and <strong>Rahul Zalkikar</strong></span>,
    year: 2021,
    title: "Limitation Learning: Capturing Adverse Dialog with Generative Adversarial Imitation Learning",
    journal: null,
    arxivLink: "https://arxiv.org/abs/2508.11767",
    pdfLink: process.env.PUBLIC_URL + "/papers/LimitationLearning.pdf",
    codeLink: "https://github.com/zalkikar/limitation-learning",
    aclLink: null,
    pdfColor: "grey",
    note: null,
    description: "Generative adversarial imitation learning "+
                 "using Seq2Seq policy model (pretrained with behavioral cloning) and discriminator, probing the behavior "+
                 "of the recovered reward signal to discover 'adversarial actions' that exist in conversation.",
  },
  {
    type: "research",
    media: PositionTrackingSnippet,
    authors: <span>Aren Dakessian, Guido Petri, and <strong>Rahul Zalkikar</strong></span>,
    year: 2020,
    title: "Synthesizing baseball data with event prediction pretraining",
    journal: null,
    arxivLink: null,
    pdfLink: process.env.PUBLIC_URL + "/papers/PositionTracking.pdf",
    codeLink: null,
    aclLink: null,
    pdfColor: "grey",
    note: null,
    description: "GRU- and LSTM-based RNNs, including autoencoder variants, "+
                 "to classify 14 baseball game events from tracking data using "+
                 "feature normalization, subsampling, and distance-based features."
  },
  {
    type: "research",
    media: ByteMagazineCoverExample,
    authors: <span>Kevin Driscoll and <strong>Rahul Zalkikar</strong></span>,
    year: 2019,
    title: "The Gender Binary of Computing: Challenging Sexism in Technology",
    journal: "Culture Digitally",
    arxivLink: null,
    pdfLink: "https://zalkikar.github.io",
    codeLink: null,
    aclLink: null,
    pdfColor: "grey",
    note: null,
    description: "Historical data analysis of Byte magazine to examine gender representation and bias in early personal computing culture.",
  },
  {
    type: "project",
    media: BboxGradCamExample,
    authors: null,
    year: 2020,
    title: "Boundary Box (bbox) Creation",
    journal: null,
    arxivLink: null,
    pdfLink: null,
    codeLink: "https://github.com/zalkikar/BBOX_GradCAM",
    aclLink: null,
    pdfColor: "grey",
    note: null,
    description: "Bbox creation using Grad-CAM heatmaps from a pretrained image classification model, "+
                 "improving IoU with vision contouring (heatmap smoothing, thresholding, contour detection) from heatmaps "+
                 "weighted by the classifier to generate polygon coordinates.",
  },
  {
    type: "project",
    media: AgentGif,
    authors: null,
    year: 2020,
    title: "Behavior Cloning for Car Racing",
    journal: null,
    arxivLink: null,
    pdfLink: null,
    codeLink: "https://github.com/zalkikar/behaviorCloning_CarRacingv0",
    aclLink: null,
    pdfColor: "grey",
    note: null,
    description: "Behavior cloning for OpenAI Gym's CarRacing-v0 environment with a CNN to mimic expert steering, acceleration, and braking."
  },
];

export default content;